import ExpenseTyeRepository from '@/shared/http/repositories/configuration/expensetype'
import TravelReasonRepository from '@/shared/http/repositories/configuration/travelreason'
import { toast } from '@/shared/utils/UIHelper.js'
import Tools from '@/components/tools/Tools.js'
export default {
  name: 'PredictionModal',
  props: {
    motivoViagemId: {
      type: String,
      default: ''
    }
  },
  watch: {
    formData (newValue) {
    }
  },
  data () {
    return {
      BoolMotivoViagem: false,
      quantidadeVazio: false,
      formData: [],
      Despesas: [],
      total: '0.0',
      integerFormat: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
      },
      moneyFormat: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      }

    }
  },
  computed: {
    getDespesaNotSelect: function () {
      return this.Despesas
    }
  },
  mounted () {
    this.$emit('onLoadThird')
    this.MotivoViagemVenda(this.motivoViagemId)
  },
  methods: {
    formatMoney (value) {
      return Tools.formatMoney(value)
    },
    AddDespesas () {
      let data = {
        id: (Math.random() * 1000).toString().replaceAll('.', ''),
        despesa: null,
        quantidade: 1,
        valorUni: 0,
        valorTotal: 0
      }
      this.formData.push(data)
    },
    verificaQuantidade () {
      const EmptyQuantidade = this.formData.some(item => item.quantidade === '')
      if (EmptyQuantidade === true) {
        this.quantidadeVazio = true
        this.$emit('quantidadeVazio', this.quantidadeVazio)
        return toast.warning('O campo quantidade deve ser preenchido')
      } else {
        this.$emit('quantidadeVazio', EmptyQuantidade)
      }
    },
    GetAllDespes (value) {
      ExpenseTyeRepository.ReembolsoNotCred(value)
        .then(Response => {
          this.Despesas = Response.data.data
        })
        .catch(Error => console.log(Error))
    },
    MotivoViagemVenda (id) {
      TravelReasonRepository.motivoViagemVenda(id)
        .then(Response => {
          this.BoolMotivoViagem = Response.data
          this.GetAllDespes(this.BoolMotivoViagem)
        })
        .catch(Error => console.log(Error))
    },
    veirifcarSelect (e) {
      if (e.target.value !== '') {
        document.getElementById('money-' + e.target.id.replace('select-', '')).disabled = false
        document.getElementById(e.target.id.replace('select-', '')).disabled = false
      } else {
        document.getElementById('money-' + e.target.id.replace('select-', '')).disabled = true
        document.getElementById(e.target.id.replace('select-', '')).disabled = true
      }
    },
    calcularTotal () {
      let total = 0.0
      this.formData.forEach((Element) => {
        total = total + (Element.quantidade * Element.valorUni)
      })
      this.total = this.formatMoney(total)
    },
    clone (data) {
      data.forEach((Element) => {
        let previsaoitens = {
          id: (Math.random() * 1000).toString().replaceAll('.', ''),
          despesa: Element.despesa,
          quantidade: Element.quantidade,
          valorUni: Element.valorUni,
          valorTotal: Element.valorTotal
        }
        this.formData.push(previsaoitens)
      })
      this.calcularTotal()
    },
    calcular (e) {
      for (let i = 0; i < this.formData.length; i++) {
        if (this.formData[i].quantidade === '' || this.formData[i].quantidade === '0') {
          this.formData[i].quantidade = 1
        }
      }
      let id = e.target.id
      if (e.target.id.includes('money-')) {
        id = id.replace('money-', '')
      }
      if (e.target.id.includes('select-')) {
        id = id.replace('select-', '')
      }

      let calcu = this.formData.find((Element) => Element.id === id)
      let total = this.formatMoney(calcu.quantidade * calcu.valorUni)
      document.querySelector('#total-' + id).value = total
      this.calcularTotal()
    },
    remove (e) {
      let aux = []
      Object.assign(aux, this.formData)
      this.formData = []
      aux.forEach((Element, index) => {
        if (Element.id !== e.target.id) {
          this.formData.push(Element)
        }
      })
      this.calcularTotal()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/travelreimbursement/components/PredictionModal/PredictionModal.js